var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default"},[_vm._m(0),_c('div',{staticClass:"panel-body"},[_c('ul',_vm._l((_vm.data.links),function(link,index){return _c('li',{key:index},[_c('a',{attrs:{"href":link.link,"target":"_blank"}},[_vm._v(_vm._s(link.title))])])}),0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-heading panel-title"},[_c('h4',[_vm._v("Links")])])
}]

export { render, staticRenderFns }